// client/src/pages/AdminRooms.jsx
import React, { useEffect, useState } from 'react';
import api from '../services/api';
import ImageUploader from '../components/imageuploader';

export default function AdminRooms() {
  const [rooms, setRooms] = useState([]);
  const [bookings, setBookings] = useState([]);

  const fetchRooms = async () => {
    try {
      const res = await api.get('/rooms');
      setRooms(res.data);
    } catch (err) {
      console.error('Failed to fetch rooms:', err);
    }
  };

    // Fetch bookings
  const fetchBookings = async () => {
    try {
      const res = await api.get('/bookings/all');
      setBookings(res.data);
    } catch (err) {
      console.error('Failed to fetch bookings:', err);
    }
  };

  useEffect(() => {
    fetchRooms();
      fetchBookings();
  }, []);

  const handleUnblock = async (roomId, blockId) => {
    try {
      await api.delete(`/rooms/${roomId}/block/${blockId}`);
      alert('Blocked date removed');
      fetchRooms(); // refresh list after unblock
    } catch (err) {
      console.error(err);
      alert('Failed to unblock date');
    }
  };

  // Helper: filter bookings for a given room
const getBookingsForRoom = (roomId) =>
  bookings.filter((b) => b.roomId && b.roomId._id === roomId);

  return (
    <div>
      <h2>Manage Rooms (Admin)</h2>
      {rooms.map((room) => (
        <div
          key={room._id}
          style={{
            border: '1px solid #ccc',
            marginBottom: '1rem',
            padding: '1rem',
          }}
        >
          <h3>{room.name}</h3>
          <p>{room.description}</p>
          <p>
            <strong>Price:</strong> ${room.price}
          </p>
          <p>
            <strong>Capacity:</strong> {room.capacity}
          </p>

          {/* Images */}
          <div>
            <h4>Images:</h4>
            <ImageUploader roomId={room._id} />
            {room.images?.map((img, idx) => (
              <img
                key={idx}
                src={img}
                alt="Room"
                style={{ width: '100px', marginRight: '8px' }}
              />
            ))}
          </div>

          {/* Blocked Dates */}
          <div>
            <h4>Blocked Dates:</h4>
            {room.blockedDates && room.blockedDates.length > 0 ? (
              <ul>
                {room.blockedDates.map((block, idx) => (
                  <li key={idx}>
                    {new Date(block.startDate).toLocaleDateString()} →{' '}
                    {new Date(block.endDate).toLocaleDateString()}{' '}
                    <button
                      onClick={() => handleUnblock(room._id, block._id)}
                      style={{ marginLeft: '10px' }}
                    >
                      Unblock
                    </button>
                  </li>
                ))}
              </ul>
            ) : (
              <p>No blocked dates</p>
            )}
          </div>
<div>
  <h4>Bookings:</h4>
  {getBookingsForRoom(room._id).length > 0 ? (
    <ul>
      {getBookingsForRoom(room._id).map((booking) => (
        <li key={booking._id}>
          {new Date(booking.checkInDate).toLocaleDateString()} →{" "}
          {new Date(booking.checkOutDate).toLocaleDateString()}
          {" | "}
          Guest: {booking.guest?.fullName} {booking.bookingId} ({booking.guest?.email})
        </li>
      ))}
    </ul>
  ) : (
    <p>No bookings</p>
  )}
</div>



        </div>
      ))}
    </div>
  );
}
